import { gql } from '@apollo/client';

export const CHANGE_PASSWORD = gql`
    mutation ChangePassword($input: ChangePasswordInput!) {
        changePassword(input: $input) {
            success
            message
        }
    }
`;

export interface ChangePasswordInput {
    countryCode: number;
    phone: string;
    newPassword: string;
    verificationCode: string;
}

export interface ChangePasswordResponse {
    changePassword: {
        success: boolean;
        message: string;
    };
}

export interface ChangePasswordVariables {
    input: ChangePasswordInput;
}

